export const APIEndpointPrefixes = {
  Notifications: 'notifications',
} as const;
